import { TranslationKeys } from "../enums/job-creation-utils.enums";

export const EXPERIENCES_OPTIONS = [
  {
    code: 'LESS_THAN_6_MONTHS',
    label: TranslationKeys.EXPERIENCE_LEVEL_LESS_THAN_6_MONTHS,
  },
  {
    code: '6_MONTHS_TO_1_YEAR',
    label: TranslationKeys.EXPERIENCE_LEVEL_SIX_MONTHS_TO_1_YEAR,
  },
  {
    code: '1_TO_2_YEARS',
    label: TranslationKeys.EXPERIENCE_LEVEL_ONE_TO_2_YEARS,
  },
  {
    code: '2_TO_3_YEARS',
    label: TranslationKeys.EXPERIENCE_LEVEL_TWO_TO_3_YEARS,
  },
  {
    code: '3_TO_4_YEARS',
    label: TranslationKeys.EXPERIENCE_LEVEL_THREE_TO_4_YEARS,
  },
  {
    code: '4_TO_5_YEARS',
    label: TranslationKeys.EXPERIENCE_LEVEL_FOUR_TO_5_YEARS,
  },
  {
    code: '5_TO_7_YEARS',
    label: TranslationKeys.EXPERIENCE_LEVEL_FIVE_TO_7_YEARS,
  },
  {
    code: '7_TO_10_YEARS',
    label: TranslationKeys.EXPERIENCE_LEVEL_SEVEN_TO_10_YEARS,
  },
  {
    code: '10_TO_15_YEARS',
    label: TranslationKeys.EXPERIENCE_LEVEL_TEN_TO_15_YEARS,
  },
  {
    code: 'MORE_THAN_15_YEARS',
    label: TranslationKeys.EXPERIENCE_LEVEL_MORE_THAN_15_YEARS,
  },
];

export const EDUCATIONS_LEVELS = [
  {
    code: 'NO_DIPLOMA',
    label: TranslationKeys.EDUCATION_LEVEL_NO_DIPLOMA,
    year: 0,
  },
  { code: 'CAP', label: TranslationKeys.EDUCATION_LEVEL_CAP, year: 0 },
  { code: 'BEP', label: TranslationKeys.EDUCATION_LEVEL_BEP, year: 0 },
  { code: 'BAC', label: TranslationKeys.EDUCATION_LEVEL_BAC, year: 1 },
  { code: 'BAC_1', label: TranslationKeys.EDUCATION_LEVEL_BAC_1, year: 1 },
  { code: 'BAC_2', label: TranslationKeys.EDUCATION_LEVEL_BAC_2, year: 2 },
  { code: 'BAC_3', label: TranslationKeys.EDUCATION_LEVEL_BAC_3, year: 3 },
  { code: 'BAC_4', label: TranslationKeys.EDUCATION_LEVEL_BAC_4, year: 4 },
  {
    code: 'BAC_5',
    label: TranslationKeys.EDUCATION_LEVEL_BAC_5_MASTER,
    year: 5,
  },
  {
    code: 'PHD',
    label: TranslationKeys.EDUCATION_LEVEL_BAC_5_DOCTORATE,
    year: 8,
  },
];

export const CONTRACTS_TYPES_OPTIONS = [
  { code: 'CDI', label: TranslationKeys.CONTRACT_TYPE_CDI },
  { code: 'CDD', label: TranslationKeys.CONTRACT_TYPE_CDD },
  { code: 'PartTime', label: TranslationKeys.CONTRACT_TYPE_PART_TIME },
  { code: 'Freelance', label: TranslationKeys.CONTRACT_TYPE_FREELANCE },
  { code: 'Internship', label: TranslationKeys.CONTRACT_TYPE_INTERNSHIP },
  { code: 'Apprenticeship', label: TranslationKeys.CONTRACT_TYPE_APPRENTICESHIP },
  {
    code: 'GraduateProgram',
    label: TranslationKeys.CONTRACT_TYPE_GRADUATE_PROGRAM,
  },
  {
    code: 'Volunteering',
    label: TranslationKeys.CONTRACT_TYPE_VOLUNTEERING,
  },
  { code: 'VDI', label: TranslationKeys.CONTRACT_TYPE_VDI },
  { code: 'Lifetime', label: TranslationKeys.CONTRACT_TYPE_VIE },
  { code: 'Mandate', label: TranslationKeys.CONTRACT_TYPE_MANDATE },
  { code: 'Temporary', label: TranslationKeys.CONTRACT_TYPE_TEMPORARY },
  { code: 'Interim', label: TranslationKeys.CONTRACT_TYPE_INTERIM },
  { code: 'Consulting', label: TranslationKeys.CONTRACT_TYPE_CONSULTING },
  { code: 'Other', label: TranslationKeys.CONTRACT_TYPE_OTHER },
];